// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"73":"72807fa199e46467","287":"6cb55d4f3038dd1f","479":"28980de98badc3f3"}[chunkId] + ".js";
};